import { render } from "./resumeChoix.vue?vue&type=template&id=664f9810"
import script from "./resumeChoix.vue?vue&type=script&lang=js"
export * from "./resumeChoix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__